import type { ADFEntity } from '@atlaskit/adf-utils/types';

import type { BlocksSnippetAri } from '@atlassian/ari';

export enum SnippetProduct {
	// Only Confluence is allowed currently but more will be added:
	// 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
	CONFLUENCE = 'CONFLUENCE',
}
export enum SnippetBodyFormat {
	// Only ADF is allowed currently but more will be added:
	// 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
	ADF = 'ADF',
}

export enum SnippetStatus {
	ACTIVE = 'active',
	DELETED = 'deleted',
}

export enum SnippetEditorModalMode {
	CREATE = 'create',
	EDIT = 'edit',
	DUPLICATE = 'duplicate',
}

/** Scope for Access field (Private/Shared) and for tagging snippets from fetch. Not sent to BE on create/update api calls. */
export enum SnippetScope {
	GLOBAL = 'GLOBAL', // Atlassian-owned templates
	USER = 'USER', // User-created private templates
	SITE = 'SITE', // User-created site-wide templates
}

export const ATLASSIAN_ACCOUNT_ID = 'atlassian' as const;

export type UserSnippetOwner = {
	accountId: string;
	displayName: string;
	avatarUrl?: string;
};

export type AtlassianSnippetOwner = {
	accountId: typeof ATLASSIAN_ACCOUNT_ID;
	displayName: 'Atlassian';
};

export type SnippetOwner = UserSnippetOwner | AtlassianSnippetOwner;

// Transformed snippet data from the block service
export type Snippet = {
	ari: BlocksSnippetAri;
	snippetId: string; // uuidv7
	name: string;
	description?: string;
	bodyFormat: SnippetBodyFormat;
	body: ADFEntity | ADFEntity[];
	product: SnippetProduct;
	label?: string;
	isFavorite: boolean;
	status: SnippetStatus;
	/** Scope for UI (Access field). Set from fetch scope; not sent to BE on create/update. */
	scope?: SnippetScope;
	createdBy: SnippetOwner;
	createdAt: Date;
	updatedAt: Date;
};

export type SnippetFavorite = {
	userId: string;
	snippetIds: BlocksSnippetAri[];
};
